export default __webpack_public_path__ + "7309161c7475a0477a141d132f8fb280.svg";